import { NavigationExtras, Params, QueryParamsHandling } from '@angular/router';
import { createAction, props } from '@ngrx/store';

/**
 * Action for navigation request.
 */
export const go = createAction('[Router] Go', props<IGoParameters>());

export const redirectToUserUrl = createAction(
  '[Router] RedirectToUserUrl',
  props<{ url: string }>(),
);

/**
 * Action for updating query parameters
 */
export const updateQueryParameters = createAction(
  '[Router] Update Query Parameters',
  props<IQueryParameterUpdateOptions>(),
);

/**
 * Action for external navigation request.
 */
export const goExternal = createAction(
  '[Router] Go External',
  props<IGoParameters>(),
);

/**
 * Action for backwards navigation.
 */
export const back = createAction('[Router] Back');

/**
 * Action for navigating forward.
 */
export const forward = createAction('[Router] Forward');

/**
 * Navigation request action parameters.
 */
export interface IGoParameters {
  /**
   * the path where we want to navigate.
   */
  commands: (string | number | unknown)[];
  /**
   * Angular router navigation extras, like query params, etc.
   */
  extras?: NavigationExtras;
}

/**
 * Query param update action parameters
 */
interface IQueryParameterUpdateOptions {
  /**
   * Query parameters to update
   */
  queryParams: Params | null;
  /**
   * Whether to replace the url, or push a new state to the browser.
   * @default true
   */
  replaceUrl?: boolean;
  /**
   * How to handle query parameters in a router link.
   * One of:
   * - `merge` : Merge new with current parameters.
   * - `preserve` : Preserve current parameters.
   * @default "merge"
   */
  queryParamsHandling?: QueryParamsHandling;
}

export const closeOverlayOutlet = createAction('[Router] Close Overlay');

export const openOverlayOutlet = createAction(
  '[Router] Open Overlay',
  props<{ overlayPath: (string | number)[] }>(),
);
